const set_scrolling_attribute = el => {
  if (el.scrollHeight > el.clientHeight) {
    el.setAttribute("scrolling", "");
  } else {
    el.removeAttribute("scrolling");
  }
};

export default {
  inserted(el) {
    window.requestAnimationFrame(() => {
      set_scrolling_attribute(el);
    });

    window.addEventListener("resize", set_scrolling_attribute(el));
  },

  componentUpdated(el) {
    set_scrolling_attribute(el);
  },

  unbind(el) {
    window.removeEventListener("resize", set_scrolling_attribute(el));
  }
};
